import React, { Component } from 'react';

import Modal from '../Modal';
import Button from '../Button';
import HotKeys from '../HotKeys';
import Tooltip from '../Tooltip';
import PageContainer from '../PageContainer';
import "./index.less";

export default class LCModal extends Component {
    state = { size: '', className: '', show: this.props.visible };
    //关闭模态框
    close = () => {
        let { onClose, closeModalEve } = this.props;
        if(typeof onClose === 'function'){
            onClose(false);
        }
        closeModalEve && closeModalEve();
        this.setState({ show: false });
    };
    /* 点击关闭按钮 */
    onHide = () => {
        let { closeModalEve, userControl } = this.props;
        if (!userControl) {
            this.close();
        }
        if (typeof closeModalEve === 'function') {
            return closeModalEve();
        }
    };

    /* 取消按钮事件 */
    cancelClick = () => {
        let { userControl, cancelBtnClick } = this.props;
        if (!userControl) {
            this.close();
        }
        if (typeof cancelBtnClick === 'function') {
            cancelBtnClick();
        }
    };

    //确认按钮事件
    beSureClick = () => {
        let { userControl, beSureBtnClick } = this.props;
        if (!userControl) {
            this.close();
        }
        if (typeof beSureBtnClick === 'function') {
            beSureBtnClick();
        }
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.visible !== this.state.visible) {
            this.setState({ show: nextProps.visible });
        }
    }

    render() {
        let { size } = this.state;
        let {
            moduleId,
            title,
            hotKeyboard = true,
            showFooter = true,
            size: propSize,
            type,
            resizable,
            showMaxButton = false,
            headerRight,
            maxButtonClick,
            content,
            className = '',
            leftBtnName = '确定',
            rightBtnName = '取消',
            showCustomBtns,
            customBtns,
            showRightBtn,
            showLeftBtn,
            zIndex,
            pageClassType,
            contentConfig = {}, //内容配置项
            mask = true,
            buttons = [],
            customerBtnClick = ()=>{}, //自定义按钮点击事件
            ...others
        } = this.props;

        let mSize = size || propSize || '';
        let max = mSize === 'max' || type === 'max';

        if (max) {
            className = `${className} simpleModal nc-modal-max`;
        } else {
            className = `${className} simpleModal `;
        }

        let finalIndex = zIndex || 200;
        let indexInfo = { id: moduleId, zIndex: finalIndex };
        let contentEle = React.Children.map(content, item=>item ? React.cloneElement(item, { ...contentConfig }) : null);
        return (
            this.state.show ? <Modal
                id={moduleId}
                fieldid={moduleId}
                ref={Modal => (this.Modal = Modal)}
                onHide={this.onHide}
                onCancel={this.onHide}
                className={className}
                size={mSize}
                {...others}
                show={true}
                mask={mask}
                indexInfo={indexInfo}
                resizable={resizable}
            >
                {!showCustomBtns && hotKeyboard && showFooter && (
                    <HotKeys
                        keyMap={{
                            sureBtnHandler:
                                HotKeys.USUAL_KEYS.MODAL_CONFIRM,
                            cancelBtnHandler:
                                HotKeys.USUAL_KEYS.MODAL_CALCEL,
                        }}
                        handlers={{
                            sureBtnHandler: () => {
                                // 确定按钮的事件 增加top的判断避免所有弹窗逻辑都被触发 by bbqin
                                if (this.beSureClick && this.Modal && this.Modal.isTopModal()) {
                                    this.beSureClick.bind(this)();
                                }
                            },
                            cancelBtnHandler: () => {
                                // 取消按钮的事件 增加top的判断避免所有弹窗逻辑都被触发  by bbqin
                                if (this.cancelClick && this.Modal && this.Modal.isTopModal()) {
                                    this.cancelClick();
                                }
                            },
                        }}
                        className="simpleModal-hotkeys-wrapper"
                        focused={true}
                        attach={document.body}
                        display="inline"
                    />
                )}
                <Modal.Header fieldid="header-area"
                    closeButton
                    showMaxButton={showMaxButton}
                    headerRight={headerRight}
                    maxButtonClick={(max, e) => {
                        maxButtonClick && maxButtonClick(max, e);
                    }}>
                    <Modal.Title fieldid={title}>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body className={!showFooter && resizable ? 'has-resize-icon' : ''}>
                    {
                        pageClassType ? (
                            <PageContainer pageClassType={pageClassType}>
                                {contentEle}
                            </PageContainer>)
                            : contentEle
                    }
                </Modal.Body>

                {showFooter ? (
                    <Modal.Footer>
                        {!showCustomBtns && showLeftBtn &&
                            (hotKeyboard ?
                                (<Tooltip
                                    placement="top"
                                    inverse
                                    overlay={`${leftBtnName}  (${HotKeys.USUAL_KEYS.MODAL_CONFIRM})`}
                                    trigger={['hover', 'focus']}
                                    className="model-helper-overlay"
                                >
                                    <Button
                                        onClick={this.beSureClick}
                                        colors="primary"
                                        tabIndex="0"
                                        fieldid="confirm"
                                    >
                                        {leftBtnName}(<span className="text-decoration-underline">Y</span>)
                                    </Button>
                                </Tooltip>
                                ) : (<Button
                                    onClick={this.beSureClick}
                                    colors="primary"
                                    tabIndex="0"
                                    fieldid="confirm"
                                >
                                    {leftBtnName}
                                </Button>))
                        }

                        {!showCustomBtns && showRightBtn &&
                            (hotKeyboard ?
                                (<Tooltip
                                    placement="top"
                                    inverse
                                    overlay={`${rightBtnName}  (${HotKeys.USUAL_KEYS.MODAL_CALCEL})`}
                                    trigger={['focus', 'hover']}
                                    className="model-helper-overlay"
                                >
                                    <Button
                                        onClick={this.cancelClick}
                                        tabIndex="0"
                                        colors="secondary"
                                        fieldid="cancel"
                                    >
                                        {rightBtnName}(<span className="text-decoration-underline">N</span>)
                                    </Button>
                                </Tooltip>
                                ) : (
                                    <Button
                                        onClick={this.cancelClick}
                                        colors="secondary"
                                        tabIndex="0"
                                        fieldid="cancel"
                                    >
                                        {rightBtnName}
                                    </Button>
                                )
                            )
                        }
                        {showCustomBtns && customBtns ? customBtns : null}
                        {showCustomBtns && Array.isArray(buttons) && buttons.map(({ name, code, type }) => {
                            return <Button key={code} colors={type} onClick={customerBtnClick.bind(this, code)}>{name}</Button>;
                        })}
                    </Modal.Footer>
                ) : null}
            </Modal> : null
        );
    }
}